import styles from "./styles.module.css";

export default function MyPlaces({
  places = [],
}) {
  return (
    <div className="flex gap-6">
      {places.map(place => (
        <div className={styles.placeCard}>
          <h3>{place.name}</h3>
          <p>
            {place.description}
          </p>
          <a href={place.gmaps_url} target="_blank">Go to Google Maps</a>
        </div>
      ))}
    </div>
  );
}
